// src/api/postService.js
import axios from 'axios';

// const API_URL = 'https://jsonplaceholder.typicode.com/posts';
// const API_URL = 'http://localhost:8080';
const API_URL = 'https://smartassistant-556047752317.us-central1.run.app/';



export const getPosts = () => axios.get(API_URL);

export const createPost = (post) => axios.post(API_URL, post);

export const updatePost = (id, updatedPost) => axios.put(`${API_URL}/${id}`, updatedPost);

export const patchPost = (id, partialUpdate) => axios.patch(`${API_URL}/${id}`, partialUpdate);